<template>
  <div v-if="campaignStatuses.CREATED === campaign.status">
    <b-button
      type="button"
      size="sm"
      variant="primary"
      v-on:click="updateCampaign"
    ><i class="fa fa-plus" ></i>Update
    </b-button>
    <b-button
      type="button"
      size="sm"
      variant="danger"
      v-on:click="cancelCampaign"
    ><i class="fa fa-close" ></i>Cancel
    </b-button>
    <b-button
      type="button"
      size="sm"
      variant="info"
      v-on:click="scheduleCampaign"
    ><i class="fa fa-calendar" ></i>Schedule
    </b-button>
    <b-button
      type="button"
      size="sm"
      variant="primary"
      v-on:click="sendCampaign"
    ><i class="fa fa-mail-forward" ></i>Send
    </b-button>
  </div>
</template>

<script>
import {Campaign} from "@/models/NewsLetter/Campaign";
import AppBtn from "@/components/base/AppBtn";
import {RepositoryFactory} from "@/services/repositories/RepositoryFactory";

const CampaignRepo = new RepositoryFactory.get('newsletterCampaign');

export default {
  name: "CampaignActions",
  components: {AppBtn},
  props: {
    campaign: {
      type: Object,
    },
  },
  data(){
    return {
      campaignStatuses: Campaign.STATUS,
    }
  },
  methods: {
    updateCampaign() {
      this.$emit('click');
      CampaignRepo
        .updateCampaign(this.campaign)
        .then(
          response => {
            this.$emit('updated', response.data.data);
          }
        )
      ;
    },
    cancelCampaign() {
      this.$emit('click');
      CampaignRepo
        .cancelCampaign(this.campaign.id)
        .then(
          response => {
            this.$emit('updated', response.data.data);
          }
        )
    },
    sendCampaign() {
      this.$emit('click');
      CampaignRepo
        .sendCampaign(this.campaign.id)
        .then(
          response => {
            this.$emit('updated', response.data.data);
          }
        )
    },
    scheduleCampaign() {
      this.$emit('click');
      CampaignRepo
        .scheduleCampaign(this.campaign.id)
        .then(
          response => {
            this.$emit('updated', response.data.data);
          }
        )
    },
  },
}
</script>
